// extracted by mini-css-extract-plugin
module.exports = {"LayoutSwitcher":"styles_LayoutSwitcher__dznpQ","switcher":"styles_switcher__uF7sN","isActive":"styles_isActive__D8D3q"};